var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.752 5.70415L8 0.400146L10.248 5.70415L16 6.19215L11.632 9.97615L12.944 15.6001L8 12.6161L3.056 15.6001L4.368 9.97615L0 6.19215L5.752 5.70415ZM8.91081 6.07322L7.99965 3.99997L7.0885 6.05512L6.64701 7.06006L5.51981 7.15059L3.19965 7.34071L4.9656 8.81643L5.8204 9.53166L5.56678 10.6L5.04075 12.7819L7.03214 11.623L7.99965 11.0617L8.96717 11.6411L10.9586 12.8L10.4325 10.6181L10.1789 9.54977L11.0337 8.83454L12.7997 7.35882L10.4795 7.1687L9.35229 7.07816L8.91081 6.07322Z",
  fill: "#636766"
})));
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "b8a441d6c2ef0cfbce5880aa80e9d26d.svg";